module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_vm._m(0), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    ref: "busqueda",
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Buscar cargos..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirst($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }, _vm.fetchSearch]
    }
  })])]), _c('div', {
    staticClass: "data"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredLista), function(o, index) {
    return _c('div', {
      key: 'cargo_lookup_' + index,
      staticClass: "usuario",
      on: {
        "click": function($event) {
          return _vm.seleccionarClick(o)
        }
      }
    }, [_c('span', {
      staticClass: "nombre"
    }, [_vm._v(" " + _vm._s(o.cargo))])])
  }), 0), (!_vm.isLoading & _vm.filteredLista.length === 0) ? _c('div', {
    staticClass: "info-message"
  }, [_c('span', [_vm._v("No se encontraron coincidencias")])]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading text-center"
  }, [_vm._m(1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Cargos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-106bd79e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Lookup_Cargo.vue
// module id = 823
// module chunks = 0